import React, { useState } from "react";
import PropTypes from "prop-types";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Sidebar from "./sidebar.js";
import logo from "../assets/Secure Dev Tool Logo clear.png";
import { useMediaQuery } from "react-responsive";

const UpThere = () => {
  const useDesktopMediaQuery = () =>
      useMediaQuery({ query: "(min-width: 1024px)" });

  const useTabletAndBelowMediaQuery = () =>
      useMediaQuery({ query: "(max-width: 1023px)" });

  const Desktop = ({ children }) => {
    const isDesktop = useDesktopMediaQuery();
    return isDesktop ? children : null;
  };

  const TabletAndBelow = ({ children }) => {
    const isTabletAndBelow = useTabletAndBelowMediaQuery();
    return isTabletAndBelow ? children : null;
  };

  const [showSidebar, setShowSidebar] = useState(false);

  const handleToggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
      <>
        {/* Main Navigation for Desktop */}
        <Navbar style={{ color: "#F7B955" }} aria-label="Main Navigation">
          <Container>
            {/* Navigation for Tablets and Below */}
            <TabletAndBelow>
              <Navbar.Brand>
                <button
                    className="btn sidebar-toggle-btn navBtn"
                    type="button"
                    onClick={handleToggleSidebar}
                >
                  <img
                      alt="Home"
                      src={logo}
                      width="40"
                      height="40"
                      className="d-inline-block align-top shadow rounded p-1"
                  />
                </button>
              </Navbar.Brand>
            </TabletAndBelow>

            {/* Desktop Navigation */}
            <Desktop>
              <Container>
                <nav
                    className="nav navbar-nav w-100 justify-content-between navCss navbar-nav"
                    aria-label="Desktop Navigation Menu"
                >
                  <Nav.Link href="/">Home</Nav.Link>
                  <Nav.Link href="/BASE64_EnDecode">BASE64 En/Decoder</Nav.Link>
                  <Nav.Link href="/URL_EnDecode">URL En/Decoder</Nav.Link>
                  <Nav.Link href="/JSON_Formatter">JSON Formatter</Nav.Link>
                  <Nav.Link href="/XML_Formatter">XML Formatter</Nav.Link>
                  <Nav.Link href="/Unix_Timestamp">Timestamp</Nav.Link>
                  <Nav.Link href="/Send_Plain_Text_Email">Send Plain Text Email</Nav.Link>
                </nav>
              </Container>
            </Desktop>
          </Container>
        </Navbar>

        {/* Sidebar Navigation */}
        <Sidebar
            show={showSidebar}
            onHide={() => setShowSidebar(false)}
            aria-label="Sidebar Navigation"
        />
      </>
  );
};

// PropTypes validation
UpThere.propTypes = {
  children: PropTypes.node,
};

export default UpThere;
